import { ComposeViewState } from 'owa-mail-compose-store';
import { getStore, AttachmentPillViewStatus } from 'owa-recent-attachment-pills';

const RIBBON_HEIGHT = 48;
const TOOLBAR_HEIGHT = 49;
const TOOLBAR_HEIGHT_FULL_COMPOSE = 56;
const RECENT_ATTACHMENT_PILLS_HEIGHT = 94;

export default function getGetBottomDockingHeightFunc(viewState: ComposeViewState) {
    return () => {
        const { isRibbonShown, isInlineCompose, composeId } = viewState;
        const pillsViewState = getStore().recentAttachmentPills.get(composeId);
        const shouldRenderPills =
            pillsViewState?.displayPills &&
            pillsViewState.attachmentsPillData.some(
                pillsData => pillsData.attachmentPillViewStatus === AttachmentPillViewStatus.Show
            );

        return (
            (isInlineCompose ? TOOLBAR_HEIGHT : TOOLBAR_HEIGHT_FULL_COMPOSE) +
            (isRibbonShown ? RIBBON_HEIGHT : 0) +
            (shouldRenderPills ? RECENT_ATTACHMENT_PILLS_HEIGHT : 0)
        );
    };
}
